import { graphql } from "api/cms-website/generated";

import { ResponsiveImageFragment } from "../primitives/responsiveImage";

export const TabbedContentTabItemFragment = graphql(/* GraphQL */ `
    fragment TabbedContentTabItemFragment on ComponentElementsTabbedContentTabItem {
        id
        customerName
        date
        label
        rating
        text
        title
        image {
            ...ResponsiveImageFragment
        }
    }
    ${ResponsiveImageFragment}
`);
